import { useEffect, useState } from 'react';
import {
  CONSENT_EVENT, COOKIE_PREFERENCES_KEY, hasAnalyticsConsentNow, readCookiePreferences, type CookiePreferences,
} from '@/lib/cookieConsent';

const NONE: CookiePreferences = { necessary: true, functional: false, analytics: false };

/** Cookie choice as React state; the check functions read storage directly so they are never stale. */
export const useConsent = () => {
  const [preferences, setPreferences] = useState<CookiePreferences>(() => readCookiePreferences() ?? NONE);
  const [hasConsent, setHasConsent] = useState(() => readCookiePreferences() !== null);

  useEffect(() => {
    const refresh = () => {
      const p = readCookiePreferences();
      setPreferences(p ?? NONE);
      setHasConsent(p !== null);
    };
    const onStorage = (e: StorageEvent) => { if (e.key === COOKIE_PREFERENCES_KEY) refresh(); };
    window.addEventListener('storage', onStorage);
    window.addEventListener(CONSENT_EVENT, refresh);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener(CONSENT_EVENT, refresh);
    };
  }, []);

  const hasAnalyticsConsent = () => hasAnalyticsConsentNow();
  const hasFunctionalConsent = () => readCookiePreferences()?.functional === true;

  return { preferences, hasConsent, hasAnalyticsConsent, hasFunctionalConsent };
};
